import axios from 'axios';
import { datajs } from '../shared/utils';

const loadMore = () => {
	const button = datajs('load-more-btn');

	if (typeof button !== 'undefined' && button !== null) {
		button.addEventListener('click', (e) => {
			e.preventDefault();

			const adminUrl = window.AppGlobals.adminUrl;
			const loaderContainer = button.closest('.m-loadMore');
			const gridContainer = datajs(loaderContainer.dataset.gridContainer) || false;

			if (!gridContainer) {
				console.error('A valid grid container to populate with additional posts is not defined');
				return;
			}

			const action = gridContainer.dataset.action;
			const currentPage = gridContainer.dataset.page;
			const termId = gridContainer.dataset.termId;
			const featuredPostIds = gridContainer.dataset.featuredPostIds;

			const params = new URLSearchParams();
			params.append('action', action);
			params.append('current_page', currentPage);
			params.append('term_id', termId);
			params.append('featured_post_ids', featuredPostIds);

			// Loading indication
			button.disabled = true;
			loaderContainer.classList.add('is-loading');

			axios.post(`${adminUrl}admin-ajax.php`, params).then((res) => {
				// Reset loading indication
				loaderContainer.classList.remove('is-loading');
				button.disabled = false;

				// Apply data
				gridContainer.innerHTML += res.data.data;
				gridContainer.dataset.page++;

				// Hide load more button if necessary
				if (gridContainer.dataset.page === gridContainer.dataset.max) {
					button.classList.add('d-none');
					button.remove();
				}
			});
		});

		// Prevent focus styling on click
		button.addEventListener('mousedown', (e) => {
			e.preventDefault();
		});
	}
};

export default loadMore;
